import { createSelector } from '@ngrx/store';
import { isNumber } from 'lodash';

import { getLimitsState } from './main.selectors';

export const getMapsBalance = createSelector(getLimitsState, (state) =>
  state.maps?.limit && state.maps?.limit !== 'unlimited' ? (state.maps as { balance: number; limit: number }) : undefined
);
export const getReachedMapsLimit = createSelector(getLimitsState, (state) =>
  state.maps && isNumber(state.maps.limit) ? state.maps.balance >= state.maps.limit : false
);

export const getArchivedMapsBalance = createSelector(getLimitsState, (state) =>
  state.archivedMaps?.limit && state.archivedMaps?.limit !== 'unlimited'
    ? (state.archivedMaps as { balance: number; limit: number })
    : undefined
);
export const getReachedArchivedMapsLimit = createSelector(getLimitsState, (state) =>
  state.archivedMaps && isNumber(state.archivedMaps.limit) ? state.archivedMaps.balance >= state.archivedMaps.limit : false
);

export const getMapsBalanceSaving = createSelector(getLimitsState, ({ status }) => status === 'LOADING');
export const getMapsBalanceError = createSelector(getLimitsState, ({ status, error }) => (status === 'ERROR' ? error : undefined));

export const getActiveMaps = createSelector(getLimitsState, ({ maps }) => maps);
